import Odoo from 'odoo-await'
import $store from '../store'
// import $router from '../router'

import { ResponseWrapper, ErrorWrapper } from './util'

import { API_URL, API_PORT, API_DATABASE } from '../.env'

let ODOO_CLI = {}

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin ({ email, password }) {
    try {
      ODOO_CLI = new Odoo({
        baseUrl: API_URL,
        port: API_PORT,
        db: API_DATABASE,
        username: email,
        password: password
      })
      await ODOO_CLI.connect()
      _setOdooClient()
      return new ResponseWrapper('ok')
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async makeLogout () {
    try {
      _destroyOdooClient()
      return new ResponseWrapper('ok')
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static getOdooClient () {
    return ODOO_CLI
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _setOdooClient () {
  $store.commit('odoo/SET_ODOO_CLIENT', ODOO_CLI)
}

function _destroyOdooClient () {
  $store.commit('odoo/DESTROY_ODOO_CLIENT')
}
